import {defineSlotRecipe} from '@chakra-ui/react3'

export const COUNTRY_SELECTOR_BUTTON_PROPS = {
    variant: 'secondaryOutline',
    size: {base: 'md', s: 'sm'}
}

export const countrySelectorLinkRecipe = defineSlotRecipe({
    className: 'country-selector-link',
    slots: ['root', 'icon'],
    base: {
        root: {
            pointerEvents: 'auto',
            // `&&` outranks the responsive Button size recipe's square icon rule.
            '&&': {
                _icon: {
                    width: {base: 'spacing-26', s: 'spacing-22'},
                    height: 'auto',
                    borderRadius: '2xs'
                }
            }
        }
    }
})
